module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Timer-f3710db8ae8b9dba3368df6ed920fd0082ba8c340bc87306df36c5e909a49dd6.svg";